<template>
  <div class="home">
    <swiper class="my-swiper" ref="mySwiper" :options="swiperOptions">
      <swiper-slide>
        <div class="page page10-1">
          <img class="bg" src="../assets/images/10-1-bg.png" alt="" />
          <div class="content">
            <img
              class="text"
              data-swiper-animation="animate__backInLeft"
              data-duration=".5s"
              data-delay="1s"
              src="../assets/images/10-1-n.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="page page10-2">
          <img class="bg" src="../assets/images/10-2-bg.png" alt="" />
          <div class="content">
            <img
              class="text"
              data-swiper-animation="animate__backInLeft"
              data-duration=".5s"
              data-delay="1s"
              src="../assets/images/10-2-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              class="p"
              src="../assets/images/10-2-p.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="page page10-3">
          <img class="bg" src="../assets/images/10-3-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__backInLeft"
              data-duration=".5s"
              src="../assets/images/10-3-n.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="page page20-1">
          <img class="bg" src="../assets/images/20-1-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="2s"
              class="text"
              src="../assets/images/20-1-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__slideInLeft"
              data-duration=".5s"
              class="p1"
              src="../assets/images/20-1-p1.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              class="p2"
              data-delay="1s"
              src="../assets/images/20-1-p2.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="page page20-2">
          <img class="bg" src="../assets/images/20-2-bg.png" alt="" />
          <div class="content">
            <img
              class="text"
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="1s"
              src="../assets/images/20-2-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              class="p"
              src="../assets/images/20-2-p1.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="page page20-3">
          <img class="bg" src="../assets/images/20-3-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="1s"
              class="text"
              src="../assets/images/20-3-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__slideInLeft"
              data-duration=".5s"
              class="p"
              src="../assets/images/20-3-p.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="page page30-1">
          <img class="bg" src="../assets/images/30-1-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="2s"
              class="text"
              src="../assets/images/30-1-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__slideInUp"
              data-duration=".5s"
              data-delay="1s"
              class="p1"
              src="../assets/images/30-1-p1.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInLeft"
              data-duration="1s"
              class="p2"
              src="../assets/images/30-1-p2.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="page page30-2">
          <img class="bg" src="../assets/images/30-2-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="1s"
              class="text"
              src="../assets/images/30-2-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              class="p"
              src="../assets/images/30-2-p.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="page page40-1">
          <img class="bg" src="../assets/images/40-1-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="1s"
              class="text"
              src="../assets/images/40-1-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              class="p"
              src="../assets/images/40-1-p.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="page page40-2">
          <img class="bg" src="../assets/images/40-2-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="2s"
              class="text"
              src="../assets/images/40-2-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              class="p"
              src="../assets/images/40-2-p.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeIn"
              data-duration=".5s"
              data-delay="1s"
              class="t"
              src="../assets/images/40-2-t.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="page page40-3">
          <img class="bg" src="../assets/images/40-3-bg.png" alt="" />
          <div class="content">
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              data-delay="2s"
              class="text"
              src="../assets/images/40-3-n.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeInUp"
              data-duration=".5s"
              class="p"
              src="../assets/images/40-3-p.png"
              alt=""
            />
            <img
              data-swiper-animation="animate__fadeIn"
              data-duration=".5s"
              data-delay="1s"
              class="t"
              src="../assets/images/40-3-t.png"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <a href="https://www.333f.com/">
      <img class="footer" src="../assets/images/footer.png" alt="" />
    </a>
    <div class="btn-panel">
      <!-- <div v-if="isContinue" class="btn" @click="keepon">继续</div>
      <div v-else class="btn" @click="stop">暂停</div> -->
      <!-- <div class="btn" @click="writeLetter">{{ btnWriteText }}</div> -->
      <div class="btn" @click="writeLetterOrLook" v-html="btnWriteText"></div>
    </div>

    <div class="modal" v-show="isShowLetterModal">
      <div class="mask"></div>
      <div class="letter">
        <img
          class="btn-close"
          @click="hideLetterModal"
          src="../assets/images/icon-btn-close.png"
          alt=""
        />
        <span class="hint">选择你喜欢的信件发送吧, 也可自行编写哦!</span>
        <div class="letter-swiper-wrapper">
          <swiper ref="lSwiper" class="letter-swiper" :options="letterSwiperOptions">
            <swiper-slide>
              <div class="letter-wrapper letter-wrapper-1">
                <img class="bg" src="../assets/images/modal-bg-1.png" alt="" />
                <textarea id="letterTextarea1" :disabled="!editable" v-model="text1"></textarea>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="letter-wrapper letter-wrapper-2">
                <img class="bg" src="../assets/images/modal-bg-2.png" alt="" />
                <textarea id="letterTextarea2" :disabled="!editable" v-model="text2"></textarea>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="letter-wrapper letter-wrapper-3">
                <img class="bg" src="../assets/images/modal-bg-3.png" alt="" />
                <textarea id="letterTextarea3" :disabled="!editable" v-model="text3"></textarea>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="letter-wrapper letter-wrapper-4">
                <img class="bg" src="../assets/images/modal-bg-4.png" alt="" />
                <textarea id="letterTextarea4" :disabled="!editable" v-model="text4"></textarea>
              </div>
            </swiper-slide>
          </swiper>
          <img
            @click="lastLetterSlide"
            class="letter-swiper-pre"
            src="../assets/images/btn-modal-pre.png"
            alt=""
          />
          <img
            @click="nextLetterSlide"
            class="letter-swiper-next"
            src="../assets/images/btn-modal-next.png"
            alt=""
          />
        </div>
        <div class="modal-btn-panel">
          <div class="btn" @click="setEditable">自定义</div>
          <div class="btn" @click="send">发送</div>
        </div>
      </div>
    </div>
    <div class="reply" v-if="isShowReply">
      <div class="mask"></div>
      <div class="content">
        <img class="bg" src="../assets/images/letter-result-bg.png" alt="" />
        <span class="num big">{{ year }}</span>
        <span class="num small">{{ year }}</span>
        <div class="btn-look" @click="lookResult"></div>
      </div>
      <img
        @click="hideReplyModal"
        class="btn-close"
        src="../assets/images/icon-btn-close.png"
        alt=""
      />
    </div>
    <img
      v-if="isPlaying"
      @click="pause"
      class="btn-audio spin"
      src="../assets/images/icon_audio_play.png"
      alt=""
    />
    <img
      v-else
      @click="play"
      class="btn-audio"
      src="../assets/images/icon_audio_pause.png"
      alt=""
    />

    <audio
      class="hidden-audio"
      id="audio"
      @ended="replay"
      ref="player"
      src="../assets/audio/Spring's story.mp3"
      preload="auto"
      controls
    ></audio>

    <div class="result" v-if="isShowResult">
      <img class="btn-close" @click="hideResult" src="../assets/images/icon-btn-close.png" alt="" />
      <img class="bg" :src="require(`../assets/images/reply-${year}.png`)" alt="" />
      <a class="link" href="https://www.333f.com/"></a>
    </div>
  </div>
</template>

<script>
import SwiperAnimation from '@cycjimmy/swiper-animation';

const swiperAnimation = new SwiperAnimation();

export default {
  name: 'Home',
  data() {
    return {
      swiperOptions: {
        on: {
          init() {
            swiperAnimation.init(this).animate();
          },
          slideChange() {
            swiperAnimation.init(this).animate();
          },
          reachEnd() {
            window.location.hash = new Date().getTime();
          },
        },
      },
      letterSwiperOptions: {
        autoHeight: true,
      },
      timer: null,
      text1: `深圳：
        我从课堂上、书本中认识了你，从电视上、从广播中知道了你，从爸爸口中听到了你的“深圳速度”。
        爸爸说这里的麦当劳是内地第一家，放暑假我爱去深圳世界之窗玩，妈妈还会带我去买来自香港的零食和柠檬茶，深圳有好多好吃的好玩的玩意儿，我很喜欢你。`,
      text2: `发件人：大学生
        深圳，你好！从小我就听说你很繁华，你是真正的大都市，上了大学，我终于亲眼见到你的真容，这里有数不尽的高楼大厦，地王大厦甚至创下了亚洲第一高楼的记录，这里还有美丽的深圳大学，有亲爱的老师同学，你是我想象中的模样。`,
      text3:
        '#来了就是深圳人# @深圳 毕业这么多年，我终于在深圳稳定下来了，挤地铁，挤公交，看过凌晨4点的京基100，终于习惯你的节奏，也终于在这里成家立业，未来一定会更美好。',
      text4:
        '深圳，你好！一转眼来到深圳二十年了，我是你的同龄人，二十年来我见证了你的蜕变，你也见证了我的成长，地处粤港澳大湾区，坐上广深港高铁，我们连接的是更宽广的世界，但这里才是我生活的根基，深圳已经成为我的第二故乡。',
      editable: false,
      isShowLetterModal: false,
      isShowReply: false,
      isShowResult: false,
      year: 10,
      isPlaying: true,
      hasResult: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    letterSwiper() {
      return this.$refs.lSwiper.$swiper;
    },
    isContinue() {
      return this.timer === null;
    },
    btnWriteText() {
      return this.hasResult ? '查 看 信 件' : '写&nbsp;&nbsp;信';
    },
  },
  mounted() {
    // this.autoPlay();
  },
  watch: {
    $route() {
      setTimeout(() => {
        if (!this.hasResult) {
          this.year = [10, 20, 30, 40][Math.floor((Math.random() * 100) % 4)];
          console.log('dady is watching random year ', this.year);
        }
        this.showReplyModal();
      }, 3000);
    },
  },
  methods: {
    autoSlide() {
      const self = this;
      this.timer = setInterval(() => {
        if (self.swiper.isEnd) {
          this.stop();
          return;
        }
        self.swiper.slideNext(500);
      }, 3000);
    },
    keepon() {
      this.swiper.slideNext(500);
      this.autoSlide();
    },
    stop() {
      clearInterval(this.timer);
      this.timer = null;
    },
    lastLetterSlide() {
      // fix this 指向混乱
      const self = this;
      self.letterSwiper.slidePrev(500);
    },
    nextLetterSlide() {
      // fix this 指向混乱
      const self = this;
      self.letterSwiper.slideNext(500);
    },
    setEditable() {
      this.editable = true;
      this[`text${this.letterSwiper.activeIndex + 1}`] = '';
      this.$nextTick(() => {
        document.getElementById(`letterTextarea${this.letterSwiper.activeIndex + 1}`).focus();
      });
    },
    showLetterModal() {
      this.isShowLetterModal = true;
    },
    hideLetterModal() {
      this.isShowLetterModal = false;
    },
    showReplyModal() {
      this.isShowReply = true;
    },
    hideReplyModal() {
      this.isShowReply = false;
    },
    writeLetterOrLook() {
      if (this.hasResult) {
        this.lookResult();
      } else {
        this.writeLetter();
      }
    },
    writeLetter() {
      this.stop();
      this.showLetterModal();
    },
    showResult() {
      this.isShowResult = true;
    },
    hideResult() {
      this.isShowResult = false;
    },
    send() {
      this.year = (this.letterSwiper.activeIndex + 1) * 10;
      this.hideLetterModal();
      this.showReplyModal();

      setTimeout(() => {
        this.hasResult = true;
      }, 2000);
    },
    lookResult() {
      this.showResult();
      setTimeout(() => {
        this.hasResult = true;
      }, 1000);
    },
    replay() {
      this.$refs.player.currentTime = 0;
      this.play();
    },
    play() {
      this.isPlaying = true;
      this.$refs.player.play();
    },
    pause() {
      this.isPlaying = false;
      this.$refs.player.pause();
    },
    // autoPlay() {
    //   const { player } = this.$refs;
    //   const payload = () => {
    //     const toPlay = setInterval(() => {
    //       console.log('beating...', player.readyState);

    //       player.play();
    //       if (player.readyState > 2) {
    //         console.log('@if');
    //         clearInterval(toPlay);
    //       }
    //     }, 1000);
    //   };

    //   player
    //     .play()
    //     .then(payload)
    //     .catch(payload);
    // },
  },
};
</script>

<style lang="scss" scoped>
.hidden-audio {
  position: absolute;
  display: block !important;
  z-index: -1;
  width: 0;
  height: 0;
}
img {
  max-width: 100%;
}
.home {
  width: 100vw;
  height: 100vh;
  background-color: #628592;

  .my-swiper {
    width: 100%;
    height: 100%;
  }

  .page {
    position: relative;
    width: 100%;
    height: 100%;
    .bg {
      width: 100%;
      height: 100%;
    }
    .content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
  }

  .btn-panel {
    position: fixed;
    bottom: 6.5rem;
    left: 0;
    z-index: 100;
    width: 100%;
    text-align: center;

    .btn {
      background-color: rgba(0, 0, 0, 0.4);
      border: solid 0.06rem rgba(255, 255, 255, 0.7);
      display: inline-block;
      padding: 0.4rem 3rem;
      border-radius: 0.85rem;

      color: white;
      line-height: 1;
      font-size: 1rem;
      white-space: nowrap;

      &:first-child {
        /* margin-right: 4rem; */
      }
    }
  }
  .footer {
    width: 14.81rem;
    height: 1.68rem;
    position: fixed;
    bottom: 1.1rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 50;
  }

  .btn-audio {
    width: 2.75rem;
    height: 2.75rem;
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 80;
  }

  .btn-audio.spin {
    animation: spin 4s linear infinite;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  .mask {
    background-color: rgba(0, 0, 0, 0.7);
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .hint {
    color: white;
    font-size: 0.7rem;
    white-space: nowrap;
    z-index: 100;
    position: absolute;
    top: 2rem;
    left: 50%;
    transform: translate(-50%);
    font-family: sans-serif;
  }
  .letter {
    .btn-close {
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 1.1rem;
      right: 1.2rem;
      z-index: 300;
    }
    .letter-swiper-wrapper {
      .letter-swiper {
        /* width: 80%; */
      }
      .letter-swiper-pre {
        width: 1.46rem;
        height: 1.46rem;
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        z-index: 200;
      }
      .letter-swiper-next {
        width: 1.46rem;
        height: 1.46rem;
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        z-index: 200;
      }
    }
    .modal-btn-panel {
      position: fixed;
      bottom: 3.5rem;
      left: 0;
      z-index: 100;
      width: 100%;
      text-align: center;

      .btn {
        background-color: rgba(0, 0, 0, 0.4);
        border: solid 0.06rem rgba(255, 255, 255, 0.7);
        display: inline-block;
        padding: 0.4rem 1.6rem;
        border-radius: 0.85rem;

        color: white;
        line-height: 1;
        font-size: 1rem;
        white-space: nowrap;

        &:first-child {
          margin-right: 4rem;
        }
      }
    }
    .letter-wrapper {
      position: relative;
      margin-top: 3rem;

      textarea {
        background: transparent;
        border: none;
        outline: none;
        position: absolute;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        top: 0;
        z-index: 100;
        color: white;
        resize: none;
        display: block;

        /* font-size: 0.75rem; */
        font-size: 1.05rem;
        line-height: 1.5;
        color: #333333;
        text-align: justify;

        /* fix safari text color */
        -webkit-text-fill-color: #333333;
        opacity: 1; /* required on iOS */
      }
      .bg {
        display: block;
        margin: 0 auto;
      }

      &.letter-wrapper-1 {
        /* margin-top: 9rem; */
        .bg {
          width: 80%;
        }
        textarea {
          margin-top: 2.5rem;
          width: 60%;
          height: 50%;
        }
      }
      &.letter-wrapper-2 {
        .bg {
          /* width: 70%; */
          width: 80%;
        }
        textarea {
          margin-top: 5.5rem;
          width: 58.5%;
          height: 50%;
        }
      }
      &.letter-wrapper-3 {
        .bg {
          /* width: 70%; */
          width: 80%;
        }
        textarea {
          margin-top: 7.5rem;
          width: 53%;
          height: 50%;
        }
      }
      &.letter-wrapper-4 {
        .bg {
          /* width: 70%; */
          width: 80%;
        }
        textarea {
          margin-top: 7.5rem;
          width: 57%;
          height: 50%;
        }
      }
    }
  }
}

.reply {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  .mask {
    background-color: rgba(0, 0, 0, 0.7);
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .content {
    position: absolute;
    bottom: 10rem;
    margin-left: 1.3rem;

    .bg {
      width: 20.5rem;
      height: 22.62rem;
    }

    .btn-look {
      width: 14rem;
      height: 3rem;
      position: absolute;
      bottom: 2rem;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
      z-index: 500;
    }
    .num.big {
      font-size: 1.6rem;
      color: #c80202;
      line-height: 1;
      position: absolute;
      left: 1.8rem;
      top: 10.7rem;
      font-family: sans-serif;
    }
    .num.small {
      font-size: 0.8rem;
      color: #012887;
      line-height: 1;
      position: absolute;
      left: 2.2rem;
      top: 13.6rem;
      font-family: sans-serif;
    }
  }
  .btn-close {
    position: absolute;
    width: 2.5rem;
    height: 2.5rem;
    bottom: 3rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
  }
}

.result {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  .btn-close {
    width: 2rem;
    height: 2rem;
    position: absolute;
    top: 1.1rem;
    left: 1.2rem;
    z-index: 300;
  }
  .bg {
    width: 100%;
    height: 100%;
  }
  a.link {
    position: absolute;
    display: block;
    width: 20rem;
    height: 4rem;
    z-index: 300;
    bottom: 0rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
  }
}

.page10-1 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 8rem;
    left: 2rem;
  }
  .p {
    width: 18.87rem;
    height: 12rem;
    position: absolute;
    top: 16.9rem;
    left: 2.8rem;
  }
}
.page10-2 .content .text {
  width: 10.34rem;
  height: 6.12rem;
  position: absolute;
  top: 10.9rem;
  left: 2rem;
}
.page10-2 .content .p {
  width: 20.62rem;
  height: 21.46rem;

  position: absolute;
  bottom: 0;
  left: 50%;
  /* transform: translate3d(-50%, 0, 0); */
  margin-left: -10.31rem;
}
.page10-3 .content img {
  width: 10.34rem;
  height: 6.12rem;
  position: absolute;
  bottom: 12rem;
  left: 1.5rem;
}

.page20-1 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 6.5rem;
    left: 1.5rem;
  }
  .p1 {
    width: 21.09rem;
    height: 23.93rem;
    position: absolute;
    bottom: 0;
    left: 2.5rem;
  }
  .p2 {
    width: 6.65rem;
    height: 18.56rem;
    position: absolute;
    bottom: 3rem;
    right: 0;
  }
}

.page20-2 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 6.6rem;
    left: 1.5rem;
  }
  .p {
    width: 18.21rem;
    height: 17.96rem;
    position: absolute;
    bottom: 3.7rem;
    left: 50%;
    /* transform: translate3d(-50%, 0, 0); */
    margin-left: -9.1rem;
  }
}

.page20-3 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 12rem;
    right: 1.5rem;
  }
  .p {
    width: 13.9rem;
    height: 22.09rem;
    position: absolute;
    bottom: 3.7rem;
    left: 2.5rem;
  }
}

.page30-1 .content {
  .text {
    width: 10.34rem;
    height: 6.8rem;
    position: absolute;
    top: 6.8rem;
    left: 1.5rem;
  }
  .p1 {
    width: 8.43rem;
    height: 21.5rem;
    position: absolute;
    bottom: 0;
    right: 2.5rem;
    z-index: 1;
  }

  .p2 {
    width: 15.15rem;
    height: 18.56rem;
    position: absolute;
    bottom: 5.2rem;
    left: 2.5rem;
  }
}

.page30-2 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 8rem;
    left: 1.5rem;
  }
  .p {
    width: 23.43rem;
    height: 20.84rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

.page40-1 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 12.2rem;
    left: 1.5rem;
  }
  .p {
    width: 15.21rem;
    height: 18.56rem;
    position: absolute;
    bottom: 0;
    left: 5rem;
  }
}

.page40-2 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 6.8rem;
    left: 1.5rem;
  }
  .p {
    width: 13.09rem;
    height: 18.65rem;
    position: absolute;
    bottom: 0;
    left: 2.6rem;
  }

  .t {
    width: 6.96rem;
    height: 7.03rem;
    position: absolute;
    bottom: 9rem;
    right: 3rem;
  }
}

.page40-3 .content {
  .text {
    width: 10.34rem;
    height: 6.12rem;
    position: absolute;
    top: 6.8rem;
    left: 1.5rem;
  }
  .p {
    width: 21.9rem;
    height: 19.28rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .t {
    width: 6.68rem;
    height: 6.78rem;
    position: absolute;
    bottom: 11.5rem;
    right: 5rem;
  }
}
</style>
